module.exports = __webpack_public_path__ + "static/media/asistenciaDisabled.44a8de64.svg";